import { gql } from "@apollo/client";

export const CREATE_MEMBER_WITH_MONTHLY_PAYMENT = gql`
  mutation CreateMemberWithMonthlyPayment(
    $address: String = ""
    $auth0_id: String = ""
    $name: String = ""
    $company_name: String = ""
    $email_address: String = ""
    $motivation: String = ""
    $phone_number: String = ""
    $receipt: Boolean = false
    $receipt_address: String = ""
    $region: String = ""
    $zip_code: String = ""
    $company_flag: Boolean = false
    $stripe_customer_id: String = ""
    $amount: Int
    $stripe_subscription_id: String = ""
    $stripe_payment_id: String = ""
    $transfer_fee: Int
    $transfer_fee_flag: Boolean = false
  ) {
    insert_members_one(
      object: {
        address: $address
        auth0_id: $auth0_id
        name: $name
        company_name: $company_name
        email_address: $email_address
        motivation: $motivation
        phone_number: $phone_number
        receipt: $receipt
        receipt_address: $receipt_address
        region: $region
        zip_code: $zip_code
        company_flag: $company_flag
        stripe_customer_id: $stripe_customer_id
        monthly_donations: {
          data: {
            amount: $amount
            email_address: $email_address
            stripe_subscription_id: $stripe_subscription_id
            transfer_fee: $transfer_fee
            transfer_fee_flag: $transfer_fee_flag
            donations: {
              data: {
                amount: $amount
                donation_type: "monthly"
                email_address: $email_address
                payment_method: "credit"
                stripe_payment_id: $stripe_payment_id
                transfer_fee: $transfer_fee
                transfer_fee_flag: $transfer_fee_flag
                member_auth0_id: $auth0_id
              }
            }
          }
        }
      }
    ) {
      id
    }
  }
`;

export const CREATE_MEMBER_WITH_ONE_TIME_PAYMENT = gql`
  mutation CreateMemberWithOneTimePayment(
    $address: String = ""
    $auth0_id: String = ""
    $name: String = ""
    $company_name: String = ""
    $email_address: String = ""
    $motivation: String = ""
    $phone_number: String = ""
    $receipt: Boolean = false
    $receipt_address: String = ""
    $region: String = ""
    $zip_code: String = ""
    $company_flag: Boolean = false
    $stripe_customer_id: String = ""
    $amount: Int
    $stripe_payment_id: String = ""
    $transfer_fee: Int
    $transfer_fee_flag: Boolean = false
  ) {
    insert_members_one(
      object: {
        address: $address
        auth0_id: $auth0_id
        name: $name
        company_name: $company_name
        email_address: $email_address
        motivation: $motivation
        phone_number: $phone_number
        receipt: $receipt
        receipt_address: $receipt_address
        region: $region
        zip_code: $zip_code
        company_flag: $company_flag
        stripe_customer_id: $stripe_customer_id
        donations: {
          data: {
            amount: $amount
            donation_type: "one_time"
            email_address: $email_address
            payment_method: "credit"
            stripe_payment_id: $stripe_payment_id
            transfer_fee: $transfer_fee
            transfer_fee_flag: $transfer_fee_flag
          }
        }
      }
    ) {
      id
    }
  }
`;

export const CREATE_MEMBER_WITH_BANK_PAYMENT = gql`
  mutation CreateMemberWithBankPayment(
    $address: String = ""
    $auth0_id: String = ""
    $name: String = ""
    $company_name: String = ""
    $email_address: String = ""
    $motivation: String = ""
    $phone_number: String = ""
    $receipt: Boolean = false
    $receipt_address: String = ""
    $region: String = ""
    $zip_code: String = ""
    $company_flag: Boolean = false
    $stripe_customer_id: String = ""
    $stripe_payment_id: String = ""
  ) {
    insert_members_one(
      object: {
        address: $address
        auth0_id: $auth0_id
        name: $name
        company_name: $company_name
        email_address: $email_address
        motivation: $motivation
        phone_number: $phone_number
        receipt: $receipt
        receipt_address: $receipt_address
        region: $region
        zip_code: $zip_code
        company_flag: $company_flag
        stripe_customer_id: $stripe_customer_id
        donations: {
          data: {
            amount: 0
            donation_type: "one_time"
            email_address: $email_address
            payment_method: "bank"
            stripe_payment_id: $stripe_payment_id
            transfer_fee: 0
            transfer_fee_flag: false
          }
        }
      }
    ) {
      id
    }
  }
`;

export const CREATE_MONTHLY_DONATION = gql`
  mutation CreateMonthlyDonation(
    $amount: Int
    $email_address: String = ""
    $member_auth0_id: String = ""
    $stripe_subscription_id: String = ""
    $transfer_fee: Int
    $transfer_fee_flag: Boolean = false
  ) {
    insert_monthly_donations_one(
      object: {
        amount: $amount
        email_address: $email_address
        member_auth0_id: $member_auth0_id
        stripe_subscription_id: $stripe_subscription_id
        transfer_fee: $transfer_fee
        transfer_fee_flag: $transfer_fee_flag
      }
    ) {
      id
    }
  }
`;

export const CREATE_DONATION = gql`
  mutation CreateDonation(
    $amount: Int = 1000
    $donation_type: String = ""
    $email_address: String = ""
    $member_auth0_id: String = ""
    $transfer_fee_flag: Boolean = false
    $transfer_fee: Int = 36
    $stripe_payment_id: String = ""
    $payment_method: String = ""
  ) {
    insert_donations_one(
      object: {
        amount: $amount
        donation_type: $donation_type
        email_address: $email_address
        member_auth0_id: $member_auth0_id
        payment_method: $payment_method
        stripe_payment_id: $stripe_payment_id
        transfer_fee: $transfer_fee
        transfer_fee_flag: $transfer_fee_flag
      }
    ) {
      id
    }
  }
`;

export const GET_MEMBER_DONATIONS = gql`
  query GetMemberDonations($auth0_id: String = "") {
    members_by_pk(auth0_id: $auth0_id) {
      donations(order_by: { created_at: desc }) {
        id
        amount
        created_at
        stripe_transactioned_at
        donation_type
        payment_method
      }
    }
  }
`;

export const GET_MEMBER_MONTHLY_DONATIONS = gql`
  query GetMemberMonthlyDonations($auth0_id: String = "") {
    members_by_pk(auth0_id: $auth0_id) {
      monthly_donations(
        order_by: { created_at: desc }
        where: { payment_end_on: { _is_null: true } }
      ) {
        id
        amount
        created_at
        stripe_subscription_id
      }
      donations(order_by: { created_at: desc }) {
        created_at
        id
        amount
      }
      stripe_customer_id
      email_address
      name
    }
  }
`;

export const GET_MEMBER = gql`
  query GetMember($auth0_id: String = "") {
    members_by_pk(auth0_id: $auth0_id) {
      address
      company_name
      email_address
      motivation
      name
      phone_number
      receipt
      receipt_address
      region
      zip_code
      auth0_id
      id
      stripe_customer_id
      company_flag
    }
  }
`;

export const GET_MEMBER_BY_EMAIL = gql`
  query GetMemberByEmail($email_address: String = "") {
    members(where: { email_address: { _eq: $email_address } }) {
      id
    }
  }
`;

export const UPDATE_MEMBER = gql`
  mutation UpdateMember(
    $auth0_id: String = ""
    $company_name: String = ""
    $address: String = ""
    $motivation: String = ""
    $name: String = ""
    $phone_number: String = ""
    $receipt: Boolean = false
    $receipt_address: String = ""
    $region: String = ""
    $zip_code: String = ""
  ) {
    update_members_by_pk(
      pk_columns: { auth0_id: $auth0_id }
      _set: {
        company_name: $company_name
        address: $address
        motivation: $motivation
        name: $name
        phone_number: $phone_number
        receipt: $receipt
        receipt_address: $receipt_address
        region: $region
        zip_code: $zip_code
      }
    ) {
      id
    }
  }
`;

export const UPDATE_MONTHLY_DONATION = gql`
  mutation UpdateMonthlyDonation(
    $id: uuid = ""
    $amount: Int = 1000
    $transfer_fee: Int = 0
    $transfer_fee_flag: Boolean = false
  ) {
    update_monthly_donations_by_pk(
      _set: {
        amount: $amount
        transfer_fee: $transfer_fee
        transfer_fee_flag: $transfer_fee_flag
      }
      pk_columns: { id: $id }
    ) {
      amount
    }
  }
`;

export const CANCEL_MONTHLY_DONATION = gql`
  mutation CancelMonthlyDonation(
    $id: uuid = ""
    $payment_end_on: timestamptz = ""
  ) {
    update_monthly_donations_by_pk(
      pk_columns: { id: $id }
      _set: { payment_end_on: $payment_end_on }
    ) {
      id
      payment_end_on
    }
  }
`;

export const RESIGN_MEMBER = gql`
  mutation ResignMember($leave_at: timestamptz = "", $auth0_id: String = "") {
    update_members_by_pk(
      pk_columns: { auth0_id: $auth0_id }
      _set: { leave_at: $leave_at }
    ) {
      leave_at
      auth0_id
      id
    }
  }
`;

export const CREATE_EVENT = gql`
  mutation CreateEvent($content: String = "") {
    insert_events_one(object: { content: $content }) {
      id
    }
  }
`;
